import { UseQueryResult } from "@tanstack/react-query"
import { Card, DataFetchWrapper } from "@tfg/ui"

type Props<TData, TError> = {
  query: UseQueryResult<TData, TError>
  children: (props: { data: TData }) => JSX.Element
  title: string
}

export const DashboardElement = <TData, TError>({
  query,
  children,
  title,
}: Props<TData, TError>) => {
  return (
    <Card>
      <Card.Header title={title} />
      <Card.Section>
        <DataFetchWrapper query={query}>{children}</DataFetchWrapper>
      </Card.Section>
    </Card>
  )
}
